import { default as aboutD2M5sqW1K7Meta } from "/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue?macro=true";
import { default as eventsafIh29SgIcMeta } from "/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93vVYWfiPlnNMeta } from "/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sampleKpR9riGsNYMeta } from "/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsEedSYi0djrMeta } from "/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93uNGfETyfMGMeta } from "/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewsiBT10Z0luMeta } from "/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexGkZLyUrXkpMeta } from "/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93BSoEybnkLMMeta } from "/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexdrpyT6OBsTMeta } from "/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93O4ukHyuYKsMeta } from "/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexyn95RdmSu8Meta } from "/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsZR0v3tRVLeMeta } from "/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordings1METnsUD2TMeta } from "/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsuTw4MO4ZfzMeta } from "/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_938Zl3QUtLQmMeta } from "/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue?macro=true";
import { default as indexCn9AE2sAhQMeta } from "/tmp/build_2b307884/pages/[studio_url]/buy/product/[product_id]/index.vue?macro=true";
import { default as confirmXqmRE5DFXkMeta } from "/tmp/build_2b307884/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue?macro=true";
import { default as confirmpkR62rjwEfMeta } from "/tmp/build_2b307884/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue?macro=true";
import { default as calendarJ4akHyRZTAMeta } from "/tmp/build_2b307884/pages/[studio_url]/calendar.vue?macro=true";
import { default as chatncvLPrROueMeta } from "/tmp/build_2b307884/pages/[studio_url]/chat.vue?macro=true";
import { default as aboutUDwPkxpEwQMeta } from "/tmp/build_2b307884/pages/[studio_url]/community-groups/[group_id]/about.vue?macro=true";
import { default as feedfu6MpESSSZMeta } from "/tmp/build_2b307884/pages/[studio_url]/community-groups/[group_id]/feed.vue?macro=true";
import { default as membersgE0ryM5H7gMeta } from "/tmp/build_2b307884/pages/[studio_url]/community-groups/[group_id]/members.vue?macro=true";
import { default as _91group_id_93vh4T1HIVqyMeta } from "/tmp/build_2b307884/pages/[studio_url]/community-groups/[group_id].vue?macro=true";
import { default as community_45profile_45edit2jVOkvCkqkMeta } from "/tmp/build_2b307884/pages/[studio_url]/community-profile-edit.vue?macro=true";
import { default as _91id_93s8A6QxwNX6Meta } from "/tmp/build_2b307884/pages/[studio_url]/community-profile/[id].vue?macro=true";
import { default as communityP3C7cxEFOhMeta } from "/tmp/build_2b307884/pages/[studio_url]/community.vue?macro=true";
import { default as _91uuid_93rS5fk6aZy1Meta } from "/tmp/build_2b307884/pages/[studio_url]/complete-registration/[uuid].vue?macro=true";
import { default as _91unique_id_936j3mfg6rP3Meta } from "/tmp/build_2b307884/pages/[studio_url]/contracts/[unique_id].vue?macro=true";
import { default as dashboardZrjiTIy9JbMeta } from "/tmp/build_2b307884/pages/[studio_url]/dashboard.vue?macro=true";
import { default as indexgjaPKq8RF0Meta } from "/tmp/build_2b307884/pages/[studio_url]/event/details/[event_id]/index.vue?macro=true";
import { default as checkoutFROh9pouDpMeta } from "/tmp/build_2b307884/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue?macro=true";
import { default as select_45productgcgoad2ASyMeta } from "/tmp/build_2b307884/pages/[studio_url]/event/details/[event_id]/select-product.vue?macro=true";
import { default as eventsGkLbivorkmMeta } from "/tmp/build_2b307884/pages/[studio_url]/events.vue?macro=true";
import { default as _91uuid_93EPKGtvxBpUMeta } from "/tmp/build_2b307884/pages/[studio_url]/gifts/[uuid].vue?macro=true";
import { default as indexLf6GjlYGNvMeta } from "/tmp/build_2b307884/pages/[studio_url]/gifts/index.vue?macro=true";
import { default as _91invitation_id_93wIbehsZzAhMeta } from "/tmp/build_2b307884/pages/[studio_url]/gifts/invitation/[invitation_id].vue?macro=true";
import { default as _91product_id_93hqQsF6bWkXMeta } from "/tmp/build_2b307884/pages/[studio_url]/gifts/product/[product_id].vue?macro=true";
import { default as indexw4lhCdFHRWMeta } from "/tmp/build_2b307884/pages/[studio_url]/index.vue?macro=true";
import { default as _91invitation_unique_id_93TuDZsUkA7sMeta } from "/tmp/build_2b307884/pages/[studio_url]/invitation/[invitation_unique_id].vue?macro=true";
import { default as joinx7bepEYduhMeta } from "/tmp/build_2b307884/pages/[studio_url]/join.vue?macro=true";
import { default as loginCyLxKeUceZMeta } from "/tmp/build_2b307884/pages/[studio_url]/login.vue?macro=true";
import { default as logoutTo1ekQGVYtMeta } from "/tmp/build_2b307884/pages/[studio_url]/logout.vue?macro=true";
import { default as _91meeting_type_slug_93DhL0fEYjH2Meta } from "/tmp/build_2b307884/pages/[studio_url]/meet/[meeting_type_slug].vue?macro=true";
import { default as _91meeting_unique_id_93v4rRHaDEjiMeta } from "/tmp/build_2b307884/pages/[studio_url]/meet/[meeting_unique_id].vue?macro=true";
import { default as _91meeting_unique_id_93egrHV64gcMMeta } from "/tmp/build_2b307884/pages/[studio_url]/meeting/[meeting_unique_id].vue?macro=true";
import { default as my_45favoritesAIXorImyeDMeta } from "/tmp/build_2b307884/pages/[studio_url]/my-favorites.vue?macro=true";
import { default as my_45studioscD6gsRoemOMeta } from "/tmp/build_2b307884/pages/[studio_url]/my-studios.vue?macro=true";
import { default as optin83FqTDdLVjMeta } from "/tmp/build_2b307884/pages/[studio_url]/optin.vue?macro=true";
import { default as _91episode_id_93aCEBEGD1ouMeta } from "/tmp/build_2b307884/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue?macro=true";
import { default as indexo9dN4ac45HMeta } from "/tmp/build_2b307884/pages/[studio_url]/podcasts/[podcast_id]/index.vue?macro=true";
import { default as indexoYTVJpOMHKMeta } from "/tmp/build_2b307884/pages/[studio_url]/podcasts/index.vue?macro=true";
import { default as aboutaPlxQgiEFOMeta } from "/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/about.vue?macro=true";
import { default as digital_45download_45contentZXJePmmTDzMeta } from "/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/digital-download-content.vue?macro=true";
import { default as events8NhfUYbKsKMeta } from "/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93iPIo2z6H9FMeta } from "/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45samplej0ZXp9pNeZMeta } from "/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsDBOcM3srinMeta } from "/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93ZjBAFrsgKxMeta } from "/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as view5D9hVLGLeWMeta } from "/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexYwgVp7e7TLMeta } from "/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93Bg3rUdutcDMeta } from "/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexm5mjuWSsn9Meta } from "/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93FypNQf87I7Meta } from "/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexgvBmOL7MUKMeta } from "/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsGPW423LraSMeta } from "/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingssSSP8If3jxMeta } from "/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsOdiJwczw3bMeta } from "/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93YkmwzeVoegMeta } from "/tmp/build_2b307884/pages/[studio_url]/product/[product_id].vue?macro=true";
import { default as index5uAeurdcpWMeta } from "/tmp/build_2b307884/pages/[studio_url]/product/index.vue?macro=true";
import { default as index3CkJbIsEudMeta } from "/tmp/build_2b307884/pages/[studio_url]/profile/index.vue?macro=true";
import { default as purchases0Uf7ula68vMeta } from "/tmp/build_2b307884/pages/[studio_url]/profile/purchases.vue?macro=true";
import { default as redemptionsQcJH5lZ1OjMeta } from "/tmp/build_2b307884/pages/[studio_url]/profile/redemptions.vue?macro=true";
import { default as _91quiz_id_933zjAs5aHZXMeta } from "/tmp/build_2b307884/pages/[studio_url]/quiz/[quiz_id].vue?macro=true";
import { default as _91token_93H6mHPr8YqtMeta } from "/tmp/build_2b307884/pages/[studio_url]/reset-password/[uid]/[token].vue?macro=true";
import { default as resetTRac6ay9VMMeta } from "/tmp/build_2b307884/pages/[studio_url]/reset.vue?macro=true";
import { default as shopGm7N7l6Q8VMeta } from "/tmp/build_2b307884/pages/[studio_url]/shop.vue?macro=true";
import { default as signupjWGtCWMRM4Meta } from "/tmp/build_2b307884/pages/[studio_url]/signup.vue?macro=true";
import { default as livehXFaitc0XMMeta } from "/tmp/build_2b307884/pages/[studio_url]/streaming/[event_id]/live.vue?macro=true";
import { default as tipsQrTsr20otxMeta } from "/tmp/build_2b307884/pages/[studio_url]/tips.vue?macro=true";
import { default as _91uuid_93UYTVW2jU01Meta } from "/tmp/build_2b307884/pages/[studio_url]/waiver/[uuid].vue?macro=true";
import { default as compactQLPJrT0EbOMeta } from "/tmp/build_2b307884/pages/[studio_url]/widgets/calendars/compact.vue?macro=true";
import { default as fullaS490YNEM8Meta } from "/tmp/build_2b307884/pages/[studio_url]/widgets/calendars/full.vue?macro=true";
export default [
  {
    name: _91product_id_938Zl3QUtLQmMeta?.name ?? "bundle-bundle_id-product-product_id",
    path: _91product_id_938Zl3QUtLQmMeta?.path ?? "/bundle/:bundle_id()/product/:product_id()",
    meta: _91product_id_938Zl3QUtLQmMeta || {},
    alias: _91product_id_938Zl3QUtLQmMeta?.alias || [],
    redirect: _91product_id_938Zl3QUtLQmMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutD2M5sqW1K7Meta?.name ?? "bundle-bundle_id-product-product_id-about",
    path: aboutD2M5sqW1K7Meta?.path ?? "about",
    meta: aboutD2M5sqW1K7Meta || {},
    alias: aboutD2M5sqW1K7Meta?.alias || [],
    redirect: aboutD2M5sqW1K7Meta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: eventsafIh29SgIcMeta?.name ?? "bundle-bundle_id-product-product_id-events",
    path: eventsafIh29SgIcMeta?.path ?? "events",
    meta: eventsafIh29SgIcMeta || {},
    alias: eventsafIh29SgIcMeta?.alias || [],
    redirect: eventsafIh29SgIcMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93vVYWfiPlnNMeta?.name ?? "bundle-bundle_id-product-product_id-free-media-media_id",
    path: _91media_id_93vVYWfiPlnNMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93vVYWfiPlnNMeta || {},
    alias: _91media_id_93vVYWfiPlnNMeta?.alias || [],
    redirect: _91media_id_93vVYWfiPlnNMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sampleKpR9riGsNYMeta?.name ?? "bundle-bundle_id-product-product_id-free-sample",
    path: free_45sampleKpR9riGsNYMeta?.path ?? "free-sample",
    meta: free_45sampleKpR9riGsNYMeta || {},
    alias: free_45sampleKpR9riGsNYMeta?.alias || [],
    redirect: free_45sampleKpR9riGsNYMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsEedSYi0djrMeta?.name ?? "bundle-bundle_id-product-product_id-included-products",
    path: included_45productsEedSYi0djrMeta?.path ?? "included-products",
    meta: included_45productsEedSYi0djrMeta || {},
    alias: included_45productsEedSYi0djrMeta?.alias || [],
    redirect: included_45productsEedSYi0djrMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93uNGfETyfMGMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93uNGfETyfMGMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93uNGfETyfMGMeta || {},
    alias: _91media_id_93uNGfETyfMGMeta?.alias || [],
    redirect: _91media_id_93uNGfETyfMGMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewsiBT10Z0luMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-view",
    path: viewsiBT10Z0luMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewsiBT10Z0luMeta || {},
    alias: viewsiBT10Z0luMeta?.alias || [],
    redirect: viewsiBT10Z0luMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexGkZLyUrXkpMeta?.name ?? "bundle-bundle_id-product-product_id-lessons",
    path: indexGkZLyUrXkpMeta?.path ?? "lessons",
    meta: indexGkZLyUrXkpMeta || {},
    alias: indexGkZLyUrXkpMeta?.alias || [],
    redirect: indexGkZLyUrXkpMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93BSoEybnkLMMeta?.name ?? "bundle-bundle_id-product-product_id-media-media_id",
    path: _91media_id_93BSoEybnkLMMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93BSoEybnkLMMeta || {},
    alias: _91media_id_93BSoEybnkLMMeta?.alias || [],
    redirect: _91media_id_93BSoEybnkLMMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexdrpyT6OBsTMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id",
    path: indexdrpyT6OBsTMeta?.path ?? "playlists/:playlist_id()",
    meta: indexdrpyT6OBsTMeta || {},
    alias: indexdrpyT6OBsTMeta?.alias || [],
    redirect: indexdrpyT6OBsTMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93O4ukHyuYKsMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93O4ukHyuYKsMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93O4ukHyuYKsMeta || {},
    alias: _91media_id_93O4ukHyuYKsMeta?.alias || [],
    redirect: _91media_id_93O4ukHyuYKsMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexyn95RdmSu8Meta?.name ?? "bundle-bundle_id-product-product_id-playlists",
    path: indexyn95RdmSu8Meta?.path ?? "playlists",
    meta: indexyn95RdmSu8Meta || {},
    alias: indexyn95RdmSu8Meta?.alias || [],
    redirect: indexyn95RdmSu8Meta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsZR0v3tRVLeMeta?.name ?? "bundle-bundle_id-product-product_id-private-sessions",
    path: private_45sessionsZR0v3tRVLeMeta?.path ?? "private-sessions",
    meta: private_45sessionsZR0v3tRVLeMeta || {},
    alias: private_45sessionsZR0v3tRVLeMeta?.alias || [],
    redirect: private_45sessionsZR0v3tRVLeMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordings1METnsUD2TMeta?.name ?? "bundle-bundle_id-product-product_id-recordings",
    path: recordings1METnsUD2TMeta?.path ?? "recordings",
    meta: recordings1METnsUD2TMeta || {},
    alias: recordings1METnsUD2TMeta?.alias || [],
    redirect: recordings1METnsUD2TMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsuTw4MO4ZfzMeta?.name ?? "bundle-bundle_id-product-product_id-reviews",
    path: reviewsuTw4MO4ZfzMeta?.path ?? "reviews",
    meta: reviewsuTw4MO4ZfzMeta || {},
    alias: reviewsuTw4MO4ZfzMeta?.alias || [],
    redirect: reviewsuTw4MO4ZfzMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexCn9AE2sAhQMeta?.name ?? "buy-product-product_id",
    path: indexCn9AE2sAhQMeta?.path ?? "/buy/product/:product_id()",
    meta: indexCn9AE2sAhQMeta || {},
    alias: indexCn9AE2sAhQMeta?.alias || [],
    redirect: indexCn9AE2sAhQMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/buy/product/[product_id]/index.vue").then(m => m.default || m)
  },
  {
    name: confirmXqmRE5DFXkMeta?.name ?? "buy-product-product_id-paypal-confirm",
    path: confirmXqmRE5DFXkMeta?.path ?? "/buy/product/:product_id()/paypal/confirm",
    meta: confirmXqmRE5DFXkMeta || {},
    alias: confirmXqmRE5DFXkMeta?.alias || [],
    redirect: confirmXqmRE5DFXkMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue").then(m => m.default || m)
  },
  {
    name: confirmpkR62rjwEfMeta?.name ?? "buy-product-product_id-stripe-confirm",
    path: confirmpkR62rjwEfMeta?.path ?? "/buy/product/:product_id()/stripe/confirm",
    meta: confirmpkR62rjwEfMeta || {},
    alias: confirmpkR62rjwEfMeta?.alias || [],
    redirect: confirmpkR62rjwEfMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue").then(m => m.default || m)
  },
  {
    name: calendarJ4akHyRZTAMeta?.name ?? "calendar",
    path: calendarJ4akHyRZTAMeta?.path ?? "/calendar",
    meta: calendarJ4akHyRZTAMeta || {},
    alias: calendarJ4akHyRZTAMeta?.alias || [],
    redirect: calendarJ4akHyRZTAMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/calendar.vue").then(m => m.default || m)
  },
  {
    name: chatncvLPrROueMeta?.name ?? "chat",
    path: chatncvLPrROueMeta?.path ?? "/chat",
    meta: chatncvLPrROueMeta || {},
    alias: chatncvLPrROueMeta?.alias || [],
    redirect: chatncvLPrROueMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/chat.vue").then(m => m.default || m)
  },
  {
    name: _91group_id_93vh4T1HIVqyMeta?.name ?? "community-groups-group_id",
    path: _91group_id_93vh4T1HIVqyMeta?.path ?? "/community-groups/:group_id()",
    meta: _91group_id_93vh4T1HIVqyMeta || {},
    alias: _91group_id_93vh4T1HIVqyMeta?.alias || [],
    redirect: _91group_id_93vh4T1HIVqyMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/community-groups/[group_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutUDwPkxpEwQMeta?.name ?? "community-groups-group_id-about",
    path: aboutUDwPkxpEwQMeta?.path ?? "about",
    meta: aboutUDwPkxpEwQMeta || {},
    alias: aboutUDwPkxpEwQMeta?.alias || [],
    redirect: aboutUDwPkxpEwQMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/community-groups/[group_id]/about.vue").then(m => m.default || m)
  },
  {
    name: feedfu6MpESSSZMeta?.name ?? "community-groups-group_id-feed",
    path: feedfu6MpESSSZMeta?.path ?? "feed",
    meta: feedfu6MpESSSZMeta || {},
    alias: feedfu6MpESSSZMeta?.alias || [],
    redirect: feedfu6MpESSSZMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/community-groups/[group_id]/feed.vue").then(m => m.default || m)
  },
  {
    name: membersgE0ryM5H7gMeta?.name ?? "community-groups-group_id-members",
    path: membersgE0ryM5H7gMeta?.path ?? "members",
    meta: membersgE0ryM5H7gMeta || {},
    alias: membersgE0ryM5H7gMeta?.alias || [],
    redirect: membersgE0ryM5H7gMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/community-groups/[group_id]/members.vue").then(m => m.default || m)
  }
]
  },
  {
    name: community_45profile_45edit2jVOkvCkqkMeta?.name ?? "community-profile-edit",
    path: community_45profile_45edit2jVOkvCkqkMeta?.path ?? "/community-profile-edit",
    meta: community_45profile_45edit2jVOkvCkqkMeta || {},
    alias: community_45profile_45edit2jVOkvCkqkMeta?.alias || [],
    redirect: community_45profile_45edit2jVOkvCkqkMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/community-profile-edit.vue").then(m => m.default || m)
  },
  {
    name: _91id_93s8A6QxwNX6Meta?.name ?? "community-profile-id",
    path: _91id_93s8A6QxwNX6Meta?.path ?? "/community-profile/:id()",
    meta: _91id_93s8A6QxwNX6Meta || {},
    alias: _91id_93s8A6QxwNX6Meta?.alias || [],
    redirect: _91id_93s8A6QxwNX6Meta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/community-profile/[id].vue").then(m => m.default || m)
  },
  {
    name: communityP3C7cxEFOhMeta?.name ?? "community",
    path: communityP3C7cxEFOhMeta?.path ?? "/community",
    meta: communityP3C7cxEFOhMeta || {},
    alias: communityP3C7cxEFOhMeta?.alias || [],
    redirect: communityP3C7cxEFOhMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/community.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93rS5fk6aZy1Meta?.name ?? "complete-registration-uuid",
    path: _91uuid_93rS5fk6aZy1Meta?.path ?? "/complete-registration/:uuid()",
    meta: _91uuid_93rS5fk6aZy1Meta || {},
    alias: _91uuid_93rS5fk6aZy1Meta?.alias || [],
    redirect: _91uuid_93rS5fk6aZy1Meta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/complete-registration/[uuid].vue").then(m => m.default || m)
  },
  {
    name: _91unique_id_936j3mfg6rP3Meta?.name ?? "contracts-unique_id",
    path: _91unique_id_936j3mfg6rP3Meta?.path ?? "/contracts/:unique_id()",
    meta: _91unique_id_936j3mfg6rP3Meta || {},
    alias: _91unique_id_936j3mfg6rP3Meta?.alias || [],
    redirect: _91unique_id_936j3mfg6rP3Meta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/contracts/[unique_id].vue").then(m => m.default || m)
  },
  {
    name: dashboardZrjiTIy9JbMeta?.name ?? "dashboard",
    path: dashboardZrjiTIy9JbMeta?.path ?? "/dashboard",
    meta: dashboardZrjiTIy9JbMeta || {},
    alias: dashboardZrjiTIy9JbMeta?.alias || [],
    redirect: dashboardZrjiTIy9JbMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/dashboard.vue").then(m => m.default || m)
  },
  {
    name: indexgjaPKq8RF0Meta?.name ?? "event-details-event_id",
    path: indexgjaPKq8RF0Meta?.path ?? "/event/details/:event_id()",
    meta: indexgjaPKq8RF0Meta || {},
    alias: indexgjaPKq8RF0Meta?.alias || [],
    redirect: indexgjaPKq8RF0Meta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/event/details/[event_id]/index.vue").then(m => m.default || m)
  },
  {
    name: checkoutFROh9pouDpMeta?.name ?? "event-details-event_id-product-product_id-checkout",
    path: checkoutFROh9pouDpMeta?.path ?? "/event/details/:event_id()/product/:product_id()/checkout",
    meta: checkoutFROh9pouDpMeta || {},
    alias: checkoutFROh9pouDpMeta?.alias || [],
    redirect: checkoutFROh9pouDpMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue").then(m => m.default || m)
  },
  {
    name: select_45productgcgoad2ASyMeta?.name ?? "event-details-event_id-select-product",
    path: select_45productgcgoad2ASyMeta?.path ?? "/event/details/:event_id()/select-product",
    meta: select_45productgcgoad2ASyMeta || {},
    alias: select_45productgcgoad2ASyMeta?.alias || [],
    redirect: select_45productgcgoad2ASyMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/event/details/[event_id]/select-product.vue").then(m => m.default || m)
  },
  {
    name: eventsGkLbivorkmMeta?.name ?? "events",
    path: eventsGkLbivorkmMeta?.path ?? "/events",
    meta: eventsGkLbivorkmMeta || {},
    alias: eventsGkLbivorkmMeta?.alias || [],
    redirect: eventsGkLbivorkmMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/events.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93EPKGtvxBpUMeta?.name ?? "gifts-uuid",
    path: _91uuid_93EPKGtvxBpUMeta?.path ?? "/gifts/:uuid()",
    meta: _91uuid_93EPKGtvxBpUMeta || {},
    alias: _91uuid_93EPKGtvxBpUMeta?.alias || [],
    redirect: _91uuid_93EPKGtvxBpUMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/gifts/[uuid].vue").then(m => m.default || m)
  },
  {
    name: indexLf6GjlYGNvMeta?.name ?? "gifts",
    path: indexLf6GjlYGNvMeta?.path ?? "/gifts",
    meta: indexLf6GjlYGNvMeta || {},
    alias: indexLf6GjlYGNvMeta?.alias || [],
    redirect: indexLf6GjlYGNvMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/gifts/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_id_93wIbehsZzAhMeta?.name ?? "gifts-invitation-invitation_id",
    path: _91invitation_id_93wIbehsZzAhMeta?.path ?? "/gifts/invitation/:invitation_id()",
    meta: _91invitation_id_93wIbehsZzAhMeta || {},
    alias: _91invitation_id_93wIbehsZzAhMeta?.alias || [],
    redirect: _91invitation_id_93wIbehsZzAhMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/gifts/invitation/[invitation_id].vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93hqQsF6bWkXMeta?.name ?? "gifts-product-product_id",
    path: _91product_id_93hqQsF6bWkXMeta?.path ?? "/gifts/product/:product_id()",
    meta: _91product_id_93hqQsF6bWkXMeta || {},
    alias: _91product_id_93hqQsF6bWkXMeta?.alias || [],
    redirect: _91product_id_93hqQsF6bWkXMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/gifts/product/[product_id].vue").then(m => m.default || m)
  },
  {
    name: indexw4lhCdFHRWMeta?.name ?? "index",
    path: indexw4lhCdFHRWMeta?.path ?? "/",
    meta: indexw4lhCdFHRWMeta || {},
    alias: indexw4lhCdFHRWMeta?.alias || [],
    redirect: indexw4lhCdFHRWMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_unique_id_93TuDZsUkA7sMeta?.name ?? "invitation-invitation_unique_id",
    path: _91invitation_unique_id_93TuDZsUkA7sMeta?.path ?? "/invitation/:invitation_unique_id()",
    meta: _91invitation_unique_id_93TuDZsUkA7sMeta || {},
    alias: _91invitation_unique_id_93TuDZsUkA7sMeta?.alias || [],
    redirect: _91invitation_unique_id_93TuDZsUkA7sMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/invitation/[invitation_unique_id].vue").then(m => m.default || m)
  },
  {
    name: joinx7bepEYduhMeta?.name ?? "join",
    path: joinx7bepEYduhMeta?.path ?? "/join",
    meta: joinx7bepEYduhMeta || {},
    alias: joinx7bepEYduhMeta?.alias || [],
    redirect: joinx7bepEYduhMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/join.vue").then(m => m.default || m)
  },
  {
    name: loginCyLxKeUceZMeta?.name ?? "login",
    path: loginCyLxKeUceZMeta?.path ?? "/login",
    meta: loginCyLxKeUceZMeta || {},
    alias: loginCyLxKeUceZMeta?.alias || [],
    redirect: loginCyLxKeUceZMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/login.vue").then(m => m.default || m)
  },
  {
    name: logoutTo1ekQGVYtMeta?.name ?? "logout",
    path: logoutTo1ekQGVYtMeta?.path ?? "/logout",
    meta: logoutTo1ekQGVYtMeta || {},
    alias: logoutTo1ekQGVYtMeta?.alias || [],
    redirect: logoutTo1ekQGVYtMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/logout.vue").then(m => m.default || m)
  },
  {
    name: _91meeting_type_slug_93DhL0fEYjH2Meta?.name ?? "meet-meeting_type_slug",
    path: _91meeting_type_slug_93DhL0fEYjH2Meta?.path ?? "/meet/:meeting_type_slug()",
    meta: _91meeting_type_slug_93DhL0fEYjH2Meta || {},
    alias: _91meeting_type_slug_93DhL0fEYjH2Meta?.alias || [],
    redirect: _91meeting_type_slug_93DhL0fEYjH2Meta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/meet/[meeting_type_slug].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93v4rRHaDEjiMeta?.name ?? "meet-meeting_unique_id",
    path: _91meeting_unique_id_93v4rRHaDEjiMeta?.path ?? "/meet/:meeting_unique_id()",
    meta: _91meeting_unique_id_93v4rRHaDEjiMeta || {},
    alias: _91meeting_unique_id_93v4rRHaDEjiMeta?.alias || [],
    redirect: _91meeting_unique_id_93v4rRHaDEjiMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/meet/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93egrHV64gcMMeta?.name ?? "meeting-meeting_unique_id",
    path: _91meeting_unique_id_93egrHV64gcMMeta?.path ?? "/meeting/:meeting_unique_id()",
    meta: _91meeting_unique_id_93egrHV64gcMMeta || {},
    alias: _91meeting_unique_id_93egrHV64gcMMeta?.alias || [],
    redirect: _91meeting_unique_id_93egrHV64gcMMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/meeting/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: my_45favoritesAIXorImyeDMeta?.name ?? "my-favorites",
    path: my_45favoritesAIXorImyeDMeta?.path ?? "/my-favorites",
    meta: my_45favoritesAIXorImyeDMeta || {},
    alias: my_45favoritesAIXorImyeDMeta?.alias || [],
    redirect: my_45favoritesAIXorImyeDMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: my_45studioscD6gsRoemOMeta?.name ?? "my-studios",
    path: my_45studioscD6gsRoemOMeta?.path ?? "/my-studios",
    meta: my_45studioscD6gsRoemOMeta || {},
    alias: my_45studioscD6gsRoemOMeta?.alias || [],
    redirect: my_45studioscD6gsRoemOMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/my-studios.vue").then(m => m.default || m)
  },
  {
    name: optin83FqTDdLVjMeta?.name ?? "optin",
    path: optin83FqTDdLVjMeta?.path ?? "/optin",
    meta: optin83FqTDdLVjMeta || {},
    alias: optin83FqTDdLVjMeta?.alias || [],
    redirect: optin83FqTDdLVjMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/optin.vue").then(m => m.default || m)
  },
  {
    name: _91episode_id_93aCEBEGD1ouMeta?.name ?? "podcasts-podcast_id-episodes-episode_id",
    path: _91episode_id_93aCEBEGD1ouMeta?.path ?? "/podcasts/:podcast_id()/episodes/:episode_id()",
    meta: _91episode_id_93aCEBEGD1ouMeta || {},
    alias: _91episode_id_93aCEBEGD1ouMeta?.alias || [],
    redirect: _91episode_id_93aCEBEGD1ouMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue").then(m => m.default || m)
  },
  {
    name: indexo9dN4ac45HMeta?.name ?? "podcasts-podcast_id",
    path: indexo9dN4ac45HMeta?.path ?? "/podcasts/:podcast_id()",
    meta: indexo9dN4ac45HMeta || {},
    alias: indexo9dN4ac45HMeta?.alias || [],
    redirect: indexo9dN4ac45HMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/podcasts/[podcast_id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexoYTVJpOMHKMeta?.name ?? "podcasts",
    path: indexoYTVJpOMHKMeta?.path ?? "/podcasts",
    meta: indexoYTVJpOMHKMeta || {},
    alias: indexoYTVJpOMHKMeta?.alias || [],
    redirect: indexoYTVJpOMHKMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/podcasts/index.vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93YkmwzeVoegMeta?.name ?? "product-product_id",
    path: _91product_id_93YkmwzeVoegMeta?.path ?? "/product/:product_id()",
    meta: _91product_id_93YkmwzeVoegMeta || {},
    alias: _91product_id_93YkmwzeVoegMeta?.alias || [],
    redirect: _91product_id_93YkmwzeVoegMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutaPlxQgiEFOMeta?.name ?? "product-product_id-about",
    path: aboutaPlxQgiEFOMeta?.path ?? "about",
    meta: aboutaPlxQgiEFOMeta || {},
    alias: aboutaPlxQgiEFOMeta?.alias || [],
    redirect: aboutaPlxQgiEFOMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: digital_45download_45contentZXJePmmTDzMeta?.name ?? "product-product_id-digital-download-content",
    path: digital_45download_45contentZXJePmmTDzMeta?.path ?? "digital-download-content",
    meta: digital_45download_45contentZXJePmmTDzMeta || {},
    alias: digital_45download_45contentZXJePmmTDzMeta?.alias || [],
    redirect: digital_45download_45contentZXJePmmTDzMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/digital-download-content.vue").then(m => m.default || m)
  },
  {
    name: events8NhfUYbKsKMeta?.name ?? "product-product_id-events",
    path: events8NhfUYbKsKMeta?.path ?? "events",
    meta: events8NhfUYbKsKMeta || {},
    alias: events8NhfUYbKsKMeta?.alias || [],
    redirect: events8NhfUYbKsKMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93iPIo2z6H9FMeta?.name ?? "product-product_id-free-media-media_id",
    path: _91media_id_93iPIo2z6H9FMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93iPIo2z6H9FMeta || {},
    alias: _91media_id_93iPIo2z6H9FMeta?.alias || [],
    redirect: _91media_id_93iPIo2z6H9FMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45samplej0ZXp9pNeZMeta?.name ?? "product-product_id-free-sample",
    path: free_45samplej0ZXp9pNeZMeta?.path ?? "free-sample",
    meta: free_45samplej0ZXp9pNeZMeta || {},
    alias: free_45samplej0ZXp9pNeZMeta?.alias || [],
    redirect: free_45samplej0ZXp9pNeZMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsDBOcM3srinMeta?.name ?? "product-product_id-included-products",
    path: included_45productsDBOcM3srinMeta?.path ?? "included-products",
    meta: included_45productsDBOcM3srinMeta || {},
    alias: included_45productsDBOcM3srinMeta?.alias || [],
    redirect: included_45productsDBOcM3srinMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93ZjBAFrsgKxMeta?.name ?? "product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93ZjBAFrsgKxMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93ZjBAFrsgKxMeta || {},
    alias: _91media_id_93ZjBAFrsgKxMeta?.alias || [],
    redirect: _91media_id_93ZjBAFrsgKxMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: view5D9hVLGLeWMeta?.name ?? "product-product_id-lessons-lesson_id-view",
    path: view5D9hVLGLeWMeta?.path ?? "lessons/:lesson_id()/view",
    meta: view5D9hVLGLeWMeta || {},
    alias: view5D9hVLGLeWMeta?.alias || [],
    redirect: view5D9hVLGLeWMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexYwgVp7e7TLMeta?.name ?? "product-product_id-lessons",
    path: indexYwgVp7e7TLMeta?.path ?? "lessons",
    meta: indexYwgVp7e7TLMeta || {},
    alias: indexYwgVp7e7TLMeta?.alias || [],
    redirect: indexYwgVp7e7TLMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93Bg3rUdutcDMeta?.name ?? "product-product_id-media-media_id",
    path: _91media_id_93Bg3rUdutcDMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93Bg3rUdutcDMeta || {},
    alias: _91media_id_93Bg3rUdutcDMeta?.alias || [],
    redirect: _91media_id_93Bg3rUdutcDMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexm5mjuWSsn9Meta?.name ?? "product-product_id-playlists-playlist_id",
    path: indexm5mjuWSsn9Meta?.path ?? "playlists/:playlist_id()",
    meta: indexm5mjuWSsn9Meta || {},
    alias: indexm5mjuWSsn9Meta?.alias || [],
    redirect: indexm5mjuWSsn9Meta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93FypNQf87I7Meta?.name ?? "product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93FypNQf87I7Meta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93FypNQf87I7Meta || {},
    alias: _91media_id_93FypNQf87I7Meta?.alias || [],
    redirect: _91media_id_93FypNQf87I7Meta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexgvBmOL7MUKMeta?.name ?? "product-product_id-playlists",
    path: indexgvBmOL7MUKMeta?.path ?? "playlists",
    meta: indexgvBmOL7MUKMeta || {},
    alias: indexgvBmOL7MUKMeta?.alias || [],
    redirect: indexgvBmOL7MUKMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsGPW423LraSMeta?.name ?? "product-product_id-private-sessions",
    path: private_45sessionsGPW423LraSMeta?.path ?? "private-sessions",
    meta: private_45sessionsGPW423LraSMeta || {},
    alias: private_45sessionsGPW423LraSMeta?.alias || [],
    redirect: private_45sessionsGPW423LraSMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingssSSP8If3jxMeta?.name ?? "product-product_id-recordings",
    path: recordingssSSP8If3jxMeta?.path ?? "recordings",
    meta: recordingssSSP8If3jxMeta || {},
    alias: recordingssSSP8If3jxMeta?.alias || [],
    redirect: recordingssSSP8If3jxMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsOdiJwczw3bMeta?.name ?? "product-product_id-reviews",
    path: reviewsOdiJwczw3bMeta?.path ?? "reviews",
    meta: reviewsOdiJwczw3bMeta || {},
    alias: reviewsOdiJwczw3bMeta?.alias || [],
    redirect: reviewsOdiJwczw3bMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: index5uAeurdcpWMeta?.name ?? "product",
    path: index5uAeurdcpWMeta?.path ?? "/product",
    meta: index5uAeurdcpWMeta || {},
    alias: index5uAeurdcpWMeta?.alias || [],
    redirect: index5uAeurdcpWMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/product/index.vue").then(m => m.default || m)
  },
  {
    name: index3CkJbIsEudMeta?.name ?? "profile",
    path: index3CkJbIsEudMeta?.path ?? "/profile",
    meta: index3CkJbIsEudMeta || {},
    alias: index3CkJbIsEudMeta?.alias || [],
    redirect: index3CkJbIsEudMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/profile/index.vue").then(m => m.default || m)
  },
  {
    name: purchases0Uf7ula68vMeta?.name ?? "profile-purchases",
    path: purchases0Uf7ula68vMeta?.path ?? "/profile/purchases",
    meta: purchases0Uf7ula68vMeta || {},
    alias: purchases0Uf7ula68vMeta?.alias || [],
    redirect: purchases0Uf7ula68vMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/profile/purchases.vue").then(m => m.default || m)
  },
  {
    name: redemptionsQcJH5lZ1OjMeta?.name ?? "profile-redemptions",
    path: redemptionsQcJH5lZ1OjMeta?.path ?? "/profile/redemptions",
    meta: redemptionsQcJH5lZ1OjMeta || {},
    alias: redemptionsQcJH5lZ1OjMeta?.alias || [],
    redirect: redemptionsQcJH5lZ1OjMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/profile/redemptions.vue").then(m => m.default || m)
  },
  {
    name: _91quiz_id_933zjAs5aHZXMeta?.name ?? "quiz-quiz_id",
    path: _91quiz_id_933zjAs5aHZXMeta?.path ?? "/quiz/:quiz_id()",
    meta: _91quiz_id_933zjAs5aHZXMeta || {},
    alias: _91quiz_id_933zjAs5aHZXMeta?.alias || [],
    redirect: _91quiz_id_933zjAs5aHZXMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/quiz/[quiz_id].vue").then(m => m.default || m)
  },
  {
    name: _91token_93H6mHPr8YqtMeta?.name ?? "reset-password-uid-token",
    path: _91token_93H6mHPr8YqtMeta?.path ?? "/reset-password/:uid()/:token()",
    meta: _91token_93H6mHPr8YqtMeta || {},
    alias: _91token_93H6mHPr8YqtMeta?.alias || [],
    redirect: _91token_93H6mHPr8YqtMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/reset-password/[uid]/[token].vue").then(m => m.default || m)
  },
  {
    name: resetTRac6ay9VMMeta?.name ?? "reset",
    path: resetTRac6ay9VMMeta?.path ?? "/reset",
    meta: resetTRac6ay9VMMeta || {},
    alias: resetTRac6ay9VMMeta?.alias || [],
    redirect: resetTRac6ay9VMMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/reset.vue").then(m => m.default || m)
  },
  {
    name: shopGm7N7l6Q8VMeta?.name ?? "shop",
    path: shopGm7N7l6Q8VMeta?.path ?? "/shop",
    meta: shopGm7N7l6Q8VMeta || {},
    alias: shopGm7N7l6Q8VMeta?.alias || [],
    redirect: shopGm7N7l6Q8VMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/shop.vue").then(m => m.default || m)
  },
  {
    name: signupjWGtCWMRM4Meta?.name ?? "signup",
    path: signupjWGtCWMRM4Meta?.path ?? "/signup",
    meta: signupjWGtCWMRM4Meta || {},
    alias: signupjWGtCWMRM4Meta?.alias || [],
    redirect: signupjWGtCWMRM4Meta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/signup.vue").then(m => m.default || m)
  },
  {
    name: livehXFaitc0XMMeta?.name ?? "streaming-event_id-live",
    path: livehXFaitc0XMMeta?.path ?? "/streaming/:event_id()/live",
    meta: livehXFaitc0XMMeta || {},
    alias: livehXFaitc0XMMeta?.alias || [],
    redirect: livehXFaitc0XMMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/streaming/[event_id]/live.vue").then(m => m.default || m)
  },
  {
    name: tipsQrTsr20otxMeta?.name ?? "tips",
    path: tipsQrTsr20otxMeta?.path ?? "/tips",
    meta: tipsQrTsr20otxMeta || {},
    alias: tipsQrTsr20otxMeta?.alias || [],
    redirect: tipsQrTsr20otxMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/tips.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93UYTVW2jU01Meta?.name ?? "waiver-uuid",
    path: _91uuid_93UYTVW2jU01Meta?.path ?? "/waiver/:uuid()",
    meta: _91uuid_93UYTVW2jU01Meta || {},
    alias: _91uuid_93UYTVW2jU01Meta?.alias || [],
    redirect: _91uuid_93UYTVW2jU01Meta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/waiver/[uuid].vue").then(m => m.default || m)
  },
  {
    name: compactQLPJrT0EbOMeta?.name ?? "widgets-calendars-compact",
    path: compactQLPJrT0EbOMeta?.path ?? "/widgets/calendars/compact",
    meta: compactQLPJrT0EbOMeta || {},
    alias: compactQLPJrT0EbOMeta?.alias || [],
    redirect: compactQLPJrT0EbOMeta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/widgets/calendars/compact.vue").then(m => m.default || m)
  },
  {
    name: fullaS490YNEM8Meta?.name ?? "widgets-calendars-full",
    path: fullaS490YNEM8Meta?.path ?? "/widgets/calendars/full",
    meta: fullaS490YNEM8Meta || {},
    alias: fullaS490YNEM8Meta?.alias || [],
    redirect: fullaS490YNEM8Meta?.redirect,
    component: () => import("/tmp/build_2b307884/pages/[studio_url]/widgets/calendars/full.vue").then(m => m.default || m)
  }
]